import { camelCase } from 'lodash'
import { getEntitySelectItemFromEntityDataItem } from '../getEntitySelectItemFromEntityDataItem'
import type { IEntityDataItem } from '~/types/models'

export function setTargetEntityPropertiesFromSourceEntityArray({
  propertyNames,
  sourceEntityArray,
  createEntitySelectItemForTarget = true,
  sourceEntitySelectItemIdPathString,
  sourceEntitySelectItemLabelPathString,
  targetEntity,
}: {
  propertyNames: string[]
  sourceEntityArray: IEntityDataItem[]
  createEntitySelectItemForTarget?: boolean
  sourceEntitySelectItemIdPathString?: string
  sourceEntitySelectItemLabelPathString?: string
  targetEntity: IEntityDataItem
}) {
  propertyNames.forEach((propName) => {
    const targetPropertyName = camelCase(propName.replace('is', ''))
    const sourceEntityPropEntity = sourceEntityArray.find((se) => se[propName])
    if (createEntitySelectItemForTarget) {
      targetEntity[targetPropertyName] = getEntitySelectItemFromEntityDataItem({
        item: sourceEntityPropEntity,
        itemIdPathString: sourceEntitySelectItemIdPathString,
        itemLabelPathString: sourceEntitySelectItemLabelPathString,
      })
      return
    }
    targetEntity[targetPropertyName] = sourceEntityPropEntity
  })
}
